import createAction, {ReducerActionInterface} from "../../../lib/reducer.utils";
import {EventModel} from "../../../models/event.model";
import {RootReducerState} from "../../root-reducer";

/* Action types */
export const EventsActionTypes = {
    SET_VALUE: "events/SET_VALUE",
    CLEAR_CONTENT: "events/CLEAR_CONTENT",
    INIT_EVENT: "events/INIT_EVENT"
}

const INITIAL_STATE: EventModel = {
    content: "",
    date: new Date().toISOString(),
    id: 0,
    permament: false,
    place: "",
    preview: "",
    slugTitle: "",
    title: ""
}

export const eventsReducer = (state = INITIAL_STATE, action: ReducerActionInterface) => {
    const { type, payload } = action;

    switch (type) {
        case EventsActionTypes.INIT_EVENT:
            return payload;

        case EventsActionTypes.CLEAR_CONTENT: return INITIAL_STATE;
        case EventsActionTypes.SET_VALUE:
            return {
                ...state,
                [payload.key]: payload.value
            }

        default: return state;
    }
}

/* Selectors */
export const getEventData = (state: RootReducerState) => state.event;

/* Actions */
export const initEvent = (payload: EventModel) => createAction({
    type: EventsActionTypes.INIT_EVENT,
    payload: payload
})

export const clearEventContent = () => createAction({
    type: EventsActionTypes.CLEAR_CONTENT
})

export const setEventValue = (key: any, value: any) => createAction({
    type: EventsActionTypes.SET_VALUE,
    payload: {
        key,
        value
    }
})